import { render, staticRenderFns } from "./filters.vue?vue&type=template&id=3b58e0f3&scoped=true"
import script from "./filters.vue?vue&type=script&lang=ts"
export * from "./filters.vue?vue&type=script&lang=ts"
import style0 from "./filters.vue?vue&type=style&index=0&id=3b58e0f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b58e0f3",
  null
  
)

export default component.exports